// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__SufHw","headerText":"styles_headerText__8TNKS","cardsContainer":"styles_cardsContainer__QIBIh","card":"styles_card__yBt_h"};